import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { DATE_CALENDAR_FORMAT } from '@core/localization/localization.constants';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CalendarRangeControlModule } from '@ui/form/calendar-range-control/calendar-range-control.module';
import { ButtonModule } from '@ui/form/button/button.module';
import { InvoiceFormField, InvoiceFormService } from './invoice-form.service';
import { AddB2BInvoiceRequest } from '@api/models/B2bService/Contract/Invoice/add-b-2-b-invoice-request';
import { TranslatePipe } from '@ngx-translate/core';


/**
 * Create an invoice form
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'b2b-invoice-form',
    templateUrl: './invoice-form.component.html',
    styleUrls: ['./invoice-form.component.scss'],
    imports: [ReactiveFormsModule, CalendarRangeControlModule, ButtonModule, TranslatePipe],
    providers: [InvoiceFormService],
})
export class InvoiceFormComponent {
    /**
     * Server pending flag
     */
    @Input() public pending: boolean;
    /**
     * B2b program id
     */
    @Input() public prgId: number;
    /**
     * Date format
     */
    public readonly calendarFormat: string = DATE_CALENDAR_FORMAT;
    /**
     * Submit form event
     *
     * @returns Form data
     */
    @Output() public createInvoice: EventEmitter<AddB2BInvoiceRequest> = new EventEmitter<AddB2BInvoiceRequest>();

    readonly #invoiceFormFormService: InvoiceFormService = inject(InvoiceFormService);

    public readonly form: FormGroup = this.#invoiceFormFormService.createReactiveForm();

    protected readonly invoiceFormField: typeof InvoiceFormField = InvoiceFormField;

    public handlerSubmit(): void {
        this.createInvoice.emit(this.#invoiceFormFormService.prepareFormDataBeforeSubmit(this.prgId));
    }
}
